import { useSelector } from "react-redux";
import { timeString } from "../../js/generateSchedule";

function ClassCard({block}) {
    const settings = useSelector(state => state.database.settings) || {tname:true, rnumber:true, period:true, pe:true, wschedule:true, homework:""};
  //  alert(settings.tname);
    return (<a data-bs-target={(block.id !== undefined && ((((!block.isMain && (settings.homework !== "" || !settings.hasOwnProperty("local"))) || (block.isMain && (block.id === "Lunch" || block.id === "MX"))))))  ? "#"+block.id.replaceAll("'", "").replaceAll(":", "").replaceAll("&", "") : null} data-bs-toggle={((block.id !== undefined && (settings.homework !== "" || !settings.hasOwnProperty("local"))) || (block.id === "Lunch" || block.id === "MX")) ?"modal" : null}><div class={block.id == "Lunch" ? "card mt-4 text-white mx-auto lunch-card": "card mt-4 text-white mx-auto class-card"}  style={{width:"15rem", background:block.color}}>



              <div class="card-body">
                <h5 class="card-title">{block.name}</h5>
                
                {(!block.isMain && settings.tname )&& <p class="card-text mb-0">
                {block.teacher}</p>}
                {(!block.isMain && settings.rnumber)&& <p class="card-text mb-0">
                {block.room}</p>}
                {(!block.isMain && settings.period)&& <p class="card-text mb-0">
                {block.period}</p>}
                <p class="card-text">
                {timeString(block.time)}
            
                
                </p>
                </div>
        </div></a>
        )
        

}
function Class({block}) {
    return (
        <li>
            <ClassCard block={block}/>
        </li>
    )
}
{/* <a data-bs-target="#<%=block[1]%>" data-bs-toggle="modal"><div class="card mt-4" style="width: 15rem; background-color: <%= block[3] %>">
              <div class="card-body">
              <h5 class="card-title"></h5>
              <p class="card-text"></p> */}

            //   <a data-bs-target="#<%=user[block[1]][0].replace(/ /g, "")%>" data-bs-toggle="modal"><div class="card mt-4" style="width: 15rem; background-color: <%= colors[user[block[1]][2].color] %>">
            //   <div class="card-body">
            //   <h5 class="card-title"></h5>
            //   <p class="card-text">
export default Class;
export {ClassCard};